import { AppButton, Card, PageHeader, Surface } from '@clickguard/design-system'
import { Lock01 } from 'components/icons'
import { ChangePlanDialog } from 'pages/workspace/billing/subscription-tab/actions/change-plan-dialog'
import { useState } from 'react'
import { PageTitle } from 'utils/page-title'
import { PostHogPath } from 'utils/posthog-events'
import 'components/page-surface/page-surface.css'

/**
 * Custom Rules on a plan that does not carry it — the state `rules-list.tsx:252` shows
 * today, kept through the redesign (DEV-2403).
 *
 * A whole page rather than a branch inside the real one: every number on that page is
 * read off rules this workspace cannot have, and the 7/30 selector drives them, so the
 * header ships without it here.
 *
 * `ChangePlanDialog`, not the old page's `window.open(billing)`: the ticket routes
 * "Upgrade plan" to the Manage Subscription modal, and the gated criteria inside the
 * rule sheet already open exactly this (`rule-sheet.tsx:810`).
 */
export const CustomRulesPlanLocked = () => {
	const [planDialogOpen, setPlanDialogOpen] = useState(false)

	return (
		<>
			<PageTitle pageName="Custom Rules" />
			<Surface
				bg="canvas"
				radius="none"
				bordered={false}
				className="cg-page-surface min-h-full"
			>
				<div className="cg-page-surface cg-header-bleed border-b border-transparent">
					<div className="px-6 pb-3 pt-4">
						<PageHeader
							layout="inline"
							title="Custom Rules"
							subtitle="Fine-tune your protection with rules built around your needs."
						/>
					</div>
				</div>

				<div className="flex flex-col gap-4 p-6 pt-4">
					<Card radius="xl" padding="compact">
						{/* Same shape as the table's own `EmptyState`, so the two read as one
						    page rather than two designs. */}
						<div className="flex flex-col items-center justify-center gap-3 px-6 py-16 text-center">
							<div className="flex h-12 w-12 items-center justify-center rounded-full border border-[rgb(var(--cg-border))] text-[rgb(var(--cg-text-tertiary))]">
								<Lock01 className="h-5 w-5" />
							</div>
							<div className="flex max-w-xs flex-col gap-1">
								<span className="text-base font-semibold text-[rgb(var(--cg-text-primary))]">
									You don&apos;t have access to Custom Rules
								</span>
								<span className="text-sm text-[rgb(var(--cg-text-secondary))]">
									Upgrade your plan to Standard or Pro tier to have access to
									this feature.
								</span>
							</div>
							<AppButton
								label="Upgrade plan"
								variant="primary"
								size="md"
								roundness="default"
								onClick={() => setPlanDialogOpen(true)}
							/>
						</div>
					</Card>
				</div>
			</Surface>
			<ChangePlanDialog
				open={planDialogOpen}
				onClose={() => setPlanDialogOpen(false)}
				path={PostHogPath.CUSTOM_RULES}
			/>
		</>
	)
}
